import { Directive, Input, HostBinding } from '@angular/core';
import {MatFormField} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';

@Directive({
  standalone: false,
  // tslint:disable-next-line:directive-selector
  selector: 'mat-form-field[provideReadonly]',
  // tslint:disable-next-line:no-host-metadata-property
  host: {
    '[class.mat-form-field-readonly]': 'isReadonlyInput()',
    '[class.mat-form-field-non-readonly]': '!isReadonlyInput()'
  }
})
export class ReadonlyStylingDirective {
  constructor(private matFormField: MatFormField) { }

  public isReadonlyInput(): boolean {
    const ctrl = this.matFormField._control;
    if (ctrl instanceof MatInput) {
      return ctrl.readonly;
    }
    return false;
  }
}
